import React, { useEffect, useState } from "react";

//UI Material
import { Breadcrumbs, Grid, Link } from "@mui/material";

//Local components
import DataLoader from "../Components/basics/DataLoader";
import ErrorBox from "../Components/ErrorBox";
import StockoutInfo from "../Components/inventory-page/StockoutInfo";
import InventoryTransactionSummary from "../Components/inventory-page/InventoryTransactionSummary";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

export default function Stockout() {
  // ==========> Component States<==========
  //State for store stockout data
  const [stockoutData, setStockoutData] = useState({});
  //State for loading
  const [dataLoader, setDataLoader] = useState(true);
  //State for error case
  const [dataError, setDataError] = useState(false);

  // ==========> Component Functions <==========
  //Function to get stockout data from db
  const getStockoutData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/inventory/get-stockout`,
        {
          stockoutId: new URLSearchParams(window.location.search).get("id"),
        }
      );
      const jsonResponse = await requestResponse.json();
      setStockoutData(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  // ==========> Component UseEffects <==========
  //UseEffect to get product data when rendering
  useEffect(() => {
    getStockoutData();
  }, []);

  // ==========> Component <==========
  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/inventory">
            Inventario
          </Link>
          <Link underline="hover" color="text.primary" aria-current="page">
            {`Salida ${new URLSearchParams(window.location.search).get("id")}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <InventoryTransactionSummary data={stockoutData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={1} alignItems="stretch" alignContent="stretch">
          <Grid item xs={12}>
            <StockoutInfo data={stockoutData} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
